"use strict";

const priceElement = document.getElementById("current--price--span");
const comparePriceElement = document.getElementById("price--compare--span");
const discountBadgeElement = document.getElementById("volume-discount-badge");
const quantityInput = document.getElementById("quantity-selector");

function parseMoneyTextToCents(text) {
  if (!text) return 0;

  const normalized = text
    .replace(/[^\d,.-]/g, "")
    .replace(/\./g, "")
    .replace(",", ".");

  const value = parseFloat(normalized);
  if (isNaN(value)) return 0;

  return Math.round(value * 100);
}

function formatMoneyFromCents(cents) {
  return (cents / 100).toFixed(2).replace(".", ",");
}

function getTierKey(amount) {
  if (amount >= 5) return 5;
  if (amount === 4) return 4;
  if (amount === 3) return 3;
  return 1;
}

function getDiscountPercent(amount) {
  const tierKey = getTierKey(amount);

  const discounts = {
    1: 0,
    3: 3,
    4: 5,
    5: 7
  };

  return discounts[tierKey] || 0;
}

function getBasePriceCents() {
  if (!priceElement) return 0;

  const datasetValue = Number(priceElement.dataset.basePriceCents);
  if (!isNaN(datasetValue) && datasetValue > 0) {
    return datasetValue;
  }

  return parseMoneyTextToCents(priceElement.textContent);
}

function getComparePriceCents() {
  if (!comparePriceElement) return 0;

  const datasetValue = Number(comparePriceElement.dataset.comparePriceCents);
  if (!isNaN(datasetValue) && datasetValue > 0) {
    return datasetValue;
  }

  return parseMoneyTextToCents(comparePriceElement.textContent);
}

function updatePriceBasedOnAmount(amount) {
  if (!priceElement) return;

  const basePriceCents = getBasePriceCents();
  if (!basePriceCents) return;

  const discountPercent = getDiscountPercent(amount);
  const discountedUnitPriceCents = Math.ceil(basePriceCents * (100 - discountPercent) / 100);

  priceElement.textContent = formatMoneyFromCents(discountedUnitPriceCents);

  if (discountBadgeElement) {
    const comparePriceCents = getComparePriceCents();

    if (comparePriceCents > 0) {
      const discountRate = ((comparePriceCents - discountedUnitPriceCents) / comparePriceCents) * 100;
      discountBadgeElement.textContent = `${Math.round(discountRate)}% korting`;
    }
  }
}

function updateSelectedTier(amount) {
  const elementOne = document.getElementById("amount-1");
  if (!elementOne) return;

  if (amount === 1 || amount === 2) {
    elementOne.classList.add("volume-discount-box-selected");

    for (let i = 3; i <= 5; i++) {
      const element = document.getElementById(`amount-${i}`);
      if (element) {
        element.classList.remove("volume-discount-box-selected");
      }
    }

    return;
  }

  elementOne.classList.remove("volume-discount-box-selected");

  for (let i = 3; i <= 5; i++) {
    const element = document.getElementById(`amount-${i}`);
    if (!element) continue;

    if (i === Math.min(5, amount)) {
      element.classList.add("volume-discount-box-selected");
    } else {
      element.classList.remove("volume-discount-box-selected");
    }
  }
}

function selectAmount(amount) {
  if (!quantityInput) return;

  if (!amount) {
    amount = Number(quantityInput.value);
  }

  amount = Math.max(1, parseInt(amount, 10) || 1);

  quantityInput.value = amount;
  updateSelectedTier(amount);
  updatePriceBasedOnAmount(amount);
}

function waitForSelectAmount() {
  if (window.location.pathname === "/cart") {
    return;
  }

  setTimeout(() => selectAmount(null), 0);
}

if (quantityInput) {
  quantityInput.addEventListener("change", waitForSelectAmount);
  quantityInput.addEventListener("input", waitForSelectAmount);
}

["more", "less"].forEach((button) => {
  const element = document.getElementById(`quantity-selector__button__${button}`);
  if (element) {
    element.addEventListener("click", waitForSelectAmount);
  }
});

[1, 3, 4, 5].forEach((amount) => {
  const element = document.getElementById(`amount-${amount}`);
  if (element) {
    element.addEventListener("click", () => selectAmount(amount));
  }
});

setTimeout(() => selectAmount(quantityInput ? Number(quantityInput.value) : 1), 0);